import { useContext, useMemo } from "react";

import { Label } from "../ui/label";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "../ui/select";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";

// A ordem importa: quem vai abrir conversa quer ver primeiro os números que
// realmente conseguem enviar. Desconectada continua na lista — o atendimento
// pode ser aberto agora e enviado quando a sessão voltar —, mas avisada.
const ordenar = (conexoes) =>
	[...conexoes].sort((a, b) => {
		const conectada = (w) => (w.status === "CONNECTED" ? 0 : 1);
		if (conectada(a) !== conectada(b)) return conectada(a) - conectada(b);
		if (a.isDefault !== b.isDefault) return a.isDefault ? -1 : 1;
		return (a.name || "").localeCompare(b.name || "");
	});

export const useConexoesDisponiveis = () => {
	const { whatsApps, loading } = useContext(WhatsAppsContext) || {};

	const conexoes = useMemo(() => ordenar(whatsApps || []), [whatsApps]);

	const padrao = useMemo(() => {
		if (!conexoes.length) return null;
		return (
			conexoes.find((w) => w.isDefault && w.status === "CONNECTED") ||
			conexoes.find((w) => w.status === "CONNECTED") ||
			conexoes.find((w) => w.isDefault) ||
			conexoes[0]
		);
	}, [conexoes]);

	return { conexoes, padrao, loading: !!loading };
};

const SelecionarConexao = ({
	value,
	onChange,
	id = "conexao",
	label = "Conexão",
	disabled,
}) => {
	const { conexoes } = useConexoesDisponiveis();

	if (!conexoes.length) return null;

	return (
		<div className="space-y-1.5">
			<Label htmlFor={id}>{label}</Label>
			<Select
				value={value ? String(value) : ""}
				onValueChange={(v) => onChange(Number(v))}
				disabled={disabled}
			>
				<SelectTrigger id={id}>
					<SelectValue placeholder="Escolha por qual número atender" />
				</SelectTrigger>
				<SelectContent>
					{conexoes.map((w) => (
						<SelectItem key={w.id} value={String(w.id)}>
							{w.name}
							{w.status !== "CONNECTED" && " (desconectada)"}
							{w.isDefault && w.status === "CONNECTED" && " (padrão)"}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
		</div>
	);
};

export default SelecionarConexao;
